module.exports = __webpack_public_path__ + "img/icon-check.f27789f7.svg";